import { getResource } from './index';
import { Constants } from '../constants';
import {UserAttributeType} from '../types/auth_types';

export const getRevenueList = async (
  user: UserAttributeType,
  currentBusinessId: string,
  pageNumber = 1,
  q = '',
  status = '',
  from = '',
  to = ''
) => {
  return await getResource(
    `/v1/admin/businesses/${currentBusinessId}/invoices?page=${pageNumber}&per_page=${Constants.PerPageCount.Revenue}&q=${q}&status=${status}&from=${from}&to=${to}`,
    user.token
  );
};

export const getLineItemList = async (
  user: UserAttributeType,
  invoiceId: number,
  pageNumber = 1
) => {
  return await getResource(
    `/v1/admin/invoices/${invoiceId}/line_items?page=${pageNumber}&per_page=${Constants.PerPageCount.LineItems}`,
    user.token
  );
};
